import { jsx, jsxs } from "react/jsx-runtime";
import { Calendar } from "../../../index.js";
import { Popover } from "@base-ui-components/react/popover";
function DatePickerDesktop({ mode, open, handlePopOverOpenState, inputNode, title, selected, handleCalendarChange, components, ...restProps }) {
    return /*#__PURE__*/ jsxs(Popover.Root, {
        open: open,
        onOpenChange: handlePopOverOpenState,
        children: [
            /*#__PURE__*/ jsx(Popover.Trigger, {
                render: inputNode,
                className: ""
            }),
            /*#__PURE__*/ jsx(Popover.Portal, {
                children: /*#__PURE__*/ jsx(Popover.Positioner, {
                    sideOffset: 12,
                    align: "start",
                    children: /*#__PURE__*/ jsxs(Popover.Popup, {
                        className: "shadow-overlay-md bg-primary-1 origin-[var(--transform-origin)] rounded-xl p-4 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[starting-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
                        children: [
                            /*#__PURE__*/ jsx(Popover.Arrow, {}),
                            /*#__PURE__*/ jsx(Popover.Title, {
                                className: "sr-only",
                                children: title
                            }),
                            /*#__PURE__*/ jsx(Calendar, {
                                selected: selected,
                                handleCalendarChange: handleCalendarChange,
                                mode: mode,
                                components: components,
                                ...restProps
                            })
                        ]
                    })
                })
            })
        ]
    });
}
export { DatePickerDesktop };
